/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelExciseTaxControl.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/excisetax-control";

export class AutogenModelExciseTaxControl<RowType extends ModelRow> extends Endpoint<RowType, RowExciseTaxControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowExciseTaxControl extends ModelRow<RowExciseTaxControlFields> {
	constructor(values?: Partial<RowExciseTaxControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowExciseTaxControlFields {
	business_id_number: string;
	business_number: string;
	company_id: string;
	create_orders_taxable: string;
	id: number;
	is_active: string;
	quebec_number: string;
}

